var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plancontainer"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.subhead))]),_vm._v(" "),_c('div',{staticClass:"text",domProps:{"innerHTML":_vm._s(_vm.conText)}}),_vm._v(" "),_c('div',{staticClass:"clearfloat"})]),_vm._v(" "),_c('footBar')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5da4d237","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/plandetail.vue
// module id = null
// module chunks = 